import { iso } from 'newtype-ts';
const _ = iso();
export const create = _.wrap;
export const fromApi = (option) => _.wrap(option);
export const name = (option) => _.unwrap(option).name;
export const value = (option) => _.unwrap(option).value;
export const valueString = (v) => v?.toString() ?? 'null';
export const valueEquals = (v1, v2) => v1 === v2;
